<template>
  <div ref="avatarroot">
    <div
      class="relative group bg-cover rounded-full bg-primary-core border border-white-50% flex items-center justify-center overflow-hidden"
      :class="rootSize"
      :style="{
        'background-color': stringToColor(displayName, 60, 40)
      }"
    >
      <img
        v-if="profileImageUri"
        :src="profileImageUri"
        class="object-cover rounded-full border border-white-10%"
        :class="imgSize"
      />
      <span v-else class="text-white font-semibold no-underline absolute" :class="textSize">
        {{ initials }}
      </span>

      <InfoTooltip v-if="tooltip" :value="displayName"></InfoTooltip>
    </div>
  </div>
</template>

<script>
import { usePeopleStore } from "@/stores/people";

export default {
  name: "PersonAvatar",

  data() {
    return {
      triedApiAgain: false
    };
  },

  props: {
    person: { type: Object, required: true },
    tooltip: { type: Boolean, default: false },
    autoloadProfilePhoto: { type: Boolean, default: false },
    size: { type: Number, default: 2 }
  },

  setup() {
    return {
      peopleStore: usePeopleStore()
    };
  },

  mounted() {
    if (this.autoloadProfilePhoto) {
      this.setupLoadPhotoObserver();
    } else {
      this.loadPhoto();
    }
  },

  computed: {
    profileImageUri() {
      if (this.person.extSysApiUserId) {
        return this.peopleStore.picture(this.person.extSysApiUserId);
      }
      return this.peopleStore.picture(this.person.emailSchoolAddress);
    },

    imgSize() {
      if (this.size === 1) {
        return "w-8 h-8";
      }
      return "w-11 h-11";
    },

    rootSize() {
      if (this.size === 1) {
        return "w-7 h-7";
      }
      return "w-10 h-10";
    },

    textSize() {
      if (this.size === 1) {
        return "text-10";
      }
      return "text-14";
    },

    displayName() {
      if (this.person.name) {
        if (this.person.name.displayName && this.person.name.displayName.length > 0) {
          return this.person.name.displayName;
        }
        return this.person.name.firstName + " " + this.person.name.lastName;
      }

      return "";
    },

    initials() {
      const indexOfLastSpace = this.displayName.lastIndexOf(" ");
      const lastName = this.displayName.substring(indexOfLastSpace + 1);
      return (this.displayName[0] + (lastName[0] || "")).toUpperCase();
    },

    identifier() {
      if (this.person.extSysApiUserId) {
        return this.person.extSysApiUserId;
      }
      return this.person.emailSchoolAddress;
    }
  },

  methods: {
    stringToColor: function (str, saturation, lightness) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return "hsl(" + h + ", " + saturation + "%, " + lightness + "%)";
    },

    setupLoadPhotoObserver() {
      const options = {
        root: null,
        threshold: "0"
      };

      const observer = new IntersectionObserver(async ([elm]) => {
        if (elm.isIntersecting) {
          await this.loadPhoto();
          observer.unobserve(this.$refs["avatarroot"]);
        }
      }, options);

      observer.observe(this.$refs["avatarroot"]);
    },

    async loadPhoto() {
      this.peopleStore.loadProfilePicture(this.person);
    }
  },

  components: {
    InfoTooltip: () => import("@/components/Shared/InfoTooltip")
  }
};
</script>

<style scoped>
img {
  max-width: 2.75rem;
  max-height: 2.75rem;
}
</style>
